import gql from 'graphql-tag';
import {
  userOpinionVendorVariantFields
} from '@graphql/VendorVariant/fragments/vendorVariantFields.graphql';

// NOTE: Make sure to include the 'id' and '__typename' in the response
// so the Apollo cache is updated correctly.
const setProductUserOpinion = gql`
  ${userOpinionVendorVariantFields}

  mutation setProductUserOpinion($vendorVariantId:ID, $opinion: Int) {
    createUpdateUserOpinionVendorVariant(userOpinion:{
      vendorVariantId:$vendorVariantId
      opinion:$opinion
    }) {
      ...userOpinionVendorVariant
    }
  }
`;

export default setProductUserOpinion;
